export default function numberWithCommas(num) {
  if (!num) return num;
  return Number.parseInt(num, 10).toLocaleString();
}
